import { useTranslation } from 'react-i18next';

const ASSESSMENT_LOOKS_SCREENSHOT = '/interview/how-the-assessment-looks.png';
/** Intrinsic pixel size of the capture (1280×800 viewport). */
const ASSESSMENT_LOOKS_SCREENSHOT_WIDTH = 1280;
const ASSESSMENT_LOOKS_SCREENSHOT_HEIGHT = 800;

/**
 * Presentational preview of the candidate assessment UI on the prep page.
 * Uses the approved static screenshot captured from /dev/assessment-looks-preview.
 */
export const AssessmentLooksPreview = () => {
  const { t } = useTranslation('interview');

  return (
    <div className="w-full">
      <h3 className="text-xl md:text-2xl font-bold text-dark-invirtus font-heading tracking-tight mb-6">
        {t('assessment_looks.title')}
      </h3>

      <div className="w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <img
          src={ASSESSMENT_LOOKS_SCREENSHOT}
          alt={t('assessment_looks.aria_label')}
          width={ASSESSMENT_LOOKS_SCREENSHOT_WIDTH}
          height={ASSESSMENT_LOOKS_SCREENSHOT_HEIGHT}
          className="block w-full h-auto object-contain"
          decoding="async"
        />
      </div>
    </div>
  );
};
